import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'lib/api';

const ATTACHMENT_URL = '/attachment/get_multiple_urls/';
const QUERY_KEY = 'getAttachment';

export type Attachment = {
  name: string;
  file: string;
  thumbnail: string;
  mime_type: string;
};

export interface AttachmentResponse {
  [key: string]: Attachment;
}

const fetchAttachment = async (
  attachmentIDs: string,
): Promise<AttachmentResponse> => {
  const response = await API.get(ATTACHMENT_URL, {
    params: { attachments: attachmentIDs },
  });
  return response.data;
};

export const useGetAttachmentQuery = (
  attachmentIDs: string,
  options?: QueryOptions<AttachmentResponse>,
): UseQueryResult<AttachmentResponse> => {
  return useQuery<AttachmentResponse>({
    queryKey: [QUERY_KEY, attachmentIDs],
    queryFn: () => fetchAttachment(attachmentIDs),
    enabled: !!attachmentIDs,
    staleTime: 0,
    ...options,
  });
};
